'use client';

/**
 * A stable callback that sets a boolean state to ONE fixed value -- the open/close, start/stop and mark-submitted
 * callbacks every menu, drawer, modal and form spelled as `useCallback(() => setX(true | false), [])`. The setter and
 * the value are the dependencies, so the identity holds across renders exactly as the empty-deps spelling did (a
 * `useState` setter never changes identity) and stays honest if a caller ever passes a non-stable setter.
 *
 * The setter is any one-argument boolean sink: a `useState` setter satisfies it, and so does a memoised notifier that
 * sets its own state and fans the value out (the page-visibility focus/blur pair).
 */

import { useCallback } from 'react';

export function useFlagSetter(setFlag: (value: boolean) => void, value: boolean): () => void {
	return useCallback(() => setFlag(value), [setFlag, value]);
}
